import {Box} from '@mui/material';
import {preventScroll} from 'common';
import {ReactNode} from 'react';

export default function InsetArea(props: {fillTop?: boolean; fillBottom?: boolean; bgcolor?: string; children: ReactNode}) {
	const {fillTop, fillBottom, bgcolor, children} = props;

	return (
		<Box
			id="inset-area"
			width="100%"
			bgcolor={bgcolor}
			paddingTop={fillTop ? 0 : 'max(env(safe-area-inset-top, 59px), 0px)'}
			paddingBottom={fillBottom ? 0 : 'max(env(safe-area-inset-bottom, 34px), 0px)'}
			sx={{
				...preventScroll,
				boxSizing: 'border-box',
				height: '100dvh',
				'@media (display-mode: standalone)': {
					height: '100vh',
				},
			}}
		>
			{children}
		</Box>
	);
}
